// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './coating.css'; // Import the CSS for styling
import coating12 from '../../image/coating12.png';
import coating1 from '../../image/coating1.png';

const Coating = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Coating Disperser & Kitchen Equipment Manufacturers and Suppliers in India</title>
        <meta
          name="description"
          content="Coating Disperser & Kitchen Equipment Manufacturers and Suppliers in India. P. Rakesh Industries offers premium coating disperser & kitchen equipment in India. Specialized in high-speed dispersers, paper coating kitchen machines, and slurry preparation units, their systems ensure efficient mixing, blending, and dispersing with durable S.S.316L impellers and precision-engineered tanks."
        />
        <meta
          property="og:title"
          content="Coating Disperser & Kitchen Equipment Manufacturers and Suppliers in India"
        />
        <meta
          property="og:description"
          content="Coating Disperser & Kitchen Equipment Manufacturers and Suppliers in India. P. Rakesh Industries offers premium coating disperser & kitchen equipment in India. Specialized in high-speed dispersers, paper coating kitchen machines, and slurry preparation units, their systems ensure efficient mixing, blending, and dispersing with durable S.S.316L impellers and precision-engineered tanks."
        />
                <meta property="og:url" content="https://pripapermachines.com/coating-disperser-and-kitchen-equipment-manufacturers-suppliers-in-india" />
        <link rel="canonical" href="https://pripapermachines.com/coating-disperser-and-kitchen-equipment-manufacturers-suppliers-in-india" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <h1 style={{color:"#4d7544"}}  className='mobileresponsiveview'>COATING DISPERSER AND KITCHEN EQUIPMENT</h1>
          <div>
            <img src={coating12} alt="Coating Disperser" />
            <h1 style={{color:"#4d7544",textAlign:"left",fontSize:"26px",marginTop:"20px"}}>Key Features:</h1>
            <ul style={{color:"black",textAlign:"left", paddingBottom:"5px"}}>
              <li>Double impeller ensures good dispersing </li>
              <br /> 
              <li>High power with stronger processing ability.</li>
              <br />
              <li>Load cell is provided to accurately measure the prepared stock.</li>
            </ul>
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <h1 style={{color:"#4d7544", marginTop:"-10px",textAlign:"left",fontSize:"40px"}}  className='desktopresponsiveview'>COATING DISPERSER AND KITCHEN EQUIPMENT</h1>
            <div className='hidedesk'>
              <img src={coating1} alt="Coating Disperser" style={{width:"80%",height:"80%"}} />
            </div>

            <div>
              <p style={{
                backgroundColor: "#4d7544",
                borderRadius: "10px",
                color: "white",
                paddingLeft: "20px",
                paddingBottom: "20px",
                paddingRight: "20px",
                paddingTop: "20px",
                width: "100%",
                boxSizing: "border-box",
                textAlign:"left"
              }}>
                Coating disperser is suitable for product dispersing, mixing, blending, and other production processes. The disperser is capable of dispersing products with low fineness and blending them into the final product directly. The impeller of the disperser has a unique saw-toothed design that intensely stirs the solution at high speed. The impeller is designed according to the size of the tank to fully disperse the material in the tank efficiently.  <br /><br />

                <div>
                  <img
                    src={coating1}
                    alt="Coating Disperser"
                    height="350px"
                    className="responsive-imagee"
                  />
                  The impeller is constructed from S.S.316L, which ensures a good life. The impeller is dynamically balanced at high RPM, resulting in a longer life of the shaft and bearings. The tank of the coating disperser is fabricated with the utmost care, ensuring good roundness and excellent workmanship. The impeller of the disperser has a unique saw-toothed design, which intensely stirs the solution at high speed. The impeller is designed according to the size of the tank to fully disperse the material in tank efficiently. Impeller is constructed from S.S. 316L which ensures good life. The Impeller is dynamically balanced at high RPM resulting in longer life of shaft and bearings. The tank of coating disperser is fabricated with utmost care ensuring good roundness and excellent workmanship.
                  <br /><br />
                  A special flush bottom valve with an end disc opening is installed at the bottom of the tank for smooth drainage. On request, hydraulic lubricating system can be provided for quick lubrication even while running process.
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coating;
